import "./App.css";
import "./Buttons.css"
import "./assets/css/layout/Modal.css"
import Auth from "./routes/Auth";
import React, { useEffect } from 'react';
import { routingData } from "./routes/routing";
import { Routes, Route } from "react-router-dom";
import RedirectRouter from "./routes/RedirectRouter";
import PageNotFound from "./page/Admin/PageNotFound";
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ToastContainer } from "react-toastify";


function App() {

  const recursiveRouter = (props) => {
    const { nestedRoutes, routes, isProtected, role, allowedRoles } = props;

    const authenticatedRouted = () => {
      return (
        <>
          {routes &&
            routes.map((e, index) => (
              <Route key={index} path={e.path} element={e.component} />
            ))}
          {nestedRoutes &&
            nestedRoutes.map((e, index) => (
              <Route path={e.path} element={e.component} key={index}>
                {recursiveRouter(e)}
              </Route>
            ))}
        </>
      );
    };

    return isProtected ? (
      <Route element={<Auth allowedRoles={allowedRoles} />}>
        {authenticatedRouted()}
      </Route>
    ) : role === "" ? (
      <Route element={<RedirectRouter />}>{authenticatedRouted()}</Route>
    ) : (
      <>{authenticatedRouted()}</>
    );
  };

  useEffect(() => {
    function handleVisibilityChange() {
      if (document.visibilityState === 'hidden') {
        localStorage.removeItem('session_token');
      }
    }
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{ zIndex: 1000000000 }}
      />
      <Routes>
        {routingData.map((e, index) => {
          return (
            <React.Fragment key={index.toString()}>
              {recursiveRouter(e)}
            </React.Fragment>
          );
        })}
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </>
  );
}

export default App;